var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from "react-hook-form";
import { useSearchContext } from "@react-components/modules/Search/SearchProvider/useSearchContext";
import { SearchInput } from "@react-components/ui/Forms/SearchInput/SearchInput";
var SearchField = function (_a) {
    var query = _a.query, placeholder = _a.placeholder, submitOnChange = _a.submitOnChange, searchPageUrl = _a.searchPageUrl, externalUrl = _a.externalUrl, dictionary = _a.dictionary, inputPrefix = _a.inputPrefix, navigateOnSubmit = _a.navigateOnSubmit;
    var _b = useSearchContext(), handleSearch = _b.handleSearch, isValidating = _b.isValidating, searchedTerm = _b.searchedTerm, siteId = _b.siteId, searchLocation = _b.searchLocation, setSearchLocation = _b.setSearchLocation;
    var _c = useForm({
        defaultValues: {
            text: query,
            searchLocation: searchLocation,
        },
    }), handleSubmit = _c.handleSubmit, register = _c.register;
    var onSubmit = function (data, e) {
        var _a;
        if (submitOnChange || navigateOnSubmit) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            var term = searchedTerm || data.text;
            window.location.href =
                searchLocation === "external"
                    ? "" + externalUrl + (term !== null && term !== void 0 ? term : "")
                    : searchPageUrl +
                        (term
                            ? "?query=" + term + "&siteId=" + siteId + "&nodeId=0&pageNumber=1&pageSize=6"
                            : "");
        }
        else {
            searchLocation === "external"
                ? (window.location.href = "" + externalUrl + data.text)
                : handleSearch((_a = data.text) !== null && _a !== void 0 ? _a : "");
        }
    };
    return (_jsx("div", __assign({ className: "search-field" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx(SearchInput, __assign({}, register("text"), { defaultValue: searchedTerm !== null && searchedTerm !== void 0 ? searchedTerm : "", placeholder: searchLocation === "internal"
                        ? placeholder
                        : dictionary === null || dictionary === void 0 ? void 0 : dictionary.placeholderExternal, "aria-label": searchLocation === "internal"
                        ? placeholder
                        : dictionary === null || dictionary === void 0 ? void 0 : dictionary.placeholderExternal, showLoader: isValidating }, (submitOnChange && {
                    onChange: function (e) {
                        var _a;
                        handleSearch((_a = e.target.value) !== null && _a !== void 0 ? _a : "");
                    },
                })), void 0), externalUrl && (_jsxs("fieldset", __assign({ className: "search-field__radio-group" }, { children: [_jsx("legend", __assign({ className: "sr-only" }, { children: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchLocationLabel }), void 0), _jsxs("div", { children: [_jsx("input", __assign({ type: "radio", id: inputPrefix + "-searchlocation-external", value: "external" }, register("searchLocation"), { onChange: function () {
                                        setSearchLocation("external");
                                    } }), void 0), _jsx("label", __assign({ htmlFor: inputPrefix + "-searchlocation-external" }, { children: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchExternalRadio }), void 0)] }, void 0), _jsxs("div", { children: [_jsx("input", __assign({ type: "radio", id: inputPrefix + "-searchlocation-internal", value: "internal" }, register("searchLocation"), { onChange: function () {
                                        setSearchLocation("internal");
                                    } }), void 0), _jsx("label", __assign({ htmlFor: inputPrefix + "-searchlocation-internal" }, { children: dictionary === null || dictionary === void 0 ? void 0 : dictionary.searchInternalRadio }), void 0)] }, void 0)] }), void 0))] }), void 0) }), void 0));
};
export { SearchField };
